import { Link } from "react-router-dom";

const IDEPage = () => {
  //   const accessToken = localStorage.getItem("usersAccessTocken");
  //   const microserviceUrl = `http://localhost:3001/?accessToken=${accessToken}`;

  return (
    <div className="px-7">
      <div className="mt-32 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mx-32">
        <div
          className="w-96 text-black"
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}>
          <div className="card-body">
            <h2 className="card-title">Project 1</h2>
            <p>
              lorem ipsum t is a long established fact that a reader will be
              distracted by the readable content
            </p>
            <div className="card-actions justify-end">
              <Link
                to="/theia-login"
                // to="http://157.245.147.52:3000/#/home/workspace-home"
                target="_blank">
                {" "}
                <button className="px-4 py-1.5 rounded-md bg-[#161B22] text-white">
                  Open IDE
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div
          className="w-96 text-black"
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}>
          <div className="card-body">
            <h2 className="card-title">Project 1</h2>
            <p>
              lorem ipsum t is a long established fact that a reader will be
              distracted by the readable content
            </p>
            <div className="card-actions justify-end">
              <Link to="/theia-login" target="_blank">
                <button className="px-4 py-1.5 rounded-md bg-[#161B22] text-white">
                  Open IDE
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IDEPage;
